---
type: guest
cover: 'https://media.codingcat.dev/image/upload/v1683044362/main-codingcatdev-photo/podcast-guest/jlengstorf'
name: Jason Lengstorf
published: published
slug: jason-lengstorf
start: January 1, 2000
picks: https://www.notion.so/Learn-CSS-on-web-dev-b053a6fcb5ba475384e2472812269ad1, https://www.notion.so/GUI-Challenges-c37331dfe86c40b6b118a50220923623, https://www.notion.so/gradient-style-1032a3c3783f4175aec4c442a27a891f
socials:
  github: 'https://github.com/jlengstorf'
  linkedin: 'https://www.linkedin.com/in/jlengstorf/'
  twitter: 'https://twitter.com/jlengstorf'
  twitch: 'https://www.twitch.tv/jlengstorf'
  youtube: 'https://www.youtube.com/channel/UCnty0z0pNRDgnuoirYXnC5A'
websites:
  - https://www.jason.af/
  - https://www.learnwithjason.dev/
  - https://www.jason.af/links/
---

## About

**Jason Lengstorf** hosts *[Learn With Jason](https://lwj.dev/)*. As a keynote speaker and author, Jason focuses on building healthier teams through trust, curiosity, and play. He's trying his very best to follow his own advice. He lives in Portland, Oregon.
